(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accessory-addons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('accessory-addons')) {
    class AccessoryAddons extends HTMLElement {
      connectedCallback() {
        this.summary = this.querySelector('.addons__summary');
        this.error = this.querySelector('.addons__error');
        this.money = new Intl.NumberFormat(this.dataset.locale || undefined, {
          style: 'currency',
          currency: this.dataset.currency || 'USD',
          currencyDisplay: 'narrowSymbol',
        });
        this.dealMin = Number(this.dataset.dealMin) || 0;
        this.touched = false;
        this.addEventListener('change', () => {
          this.touched = true;
          this.update();
        });
        this.onQuantityChange = this.onQuantityChange.bind(this);
        document.addEventListener('change', this.onQuantityChange);
        this.onSubmit = this.onSubmit.bind(this);
        window.addEventListener('submit', this.onSubmit, true);
        this.syncDeal();
        this.update();
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.onQuantityChange);
        window.removeEventListener('submit', this.onSubmit, true);
      }

      get quantity() {
        const form = document.getElementById(this.dataset.formId);
        const field =
          document.querySelector(`input[name="quantity"][form="${this.dataset.formId}"]:checked`) ||
          form?.querySelector('input[name="quantity"]:checked, input[name="quantity"]:not([type="radio"])');
        return Number(field?.value) || 1;
      }

      get dealActive() {
        return this.quantity >= this.dealMin;
      }

      onQuantityChange(event) {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || input.name !== 'quantity') return;
        if (input.getAttribute('form') !== this.dataset.formId && input.form?.getAttribute('id') !== this.dataset.formId) return;
        this.syncDeal();
        this.update();
      }

      // Show deal or full prices, and (until the shopper ticks something themselves) only
      // pre-tick the first accessory while the deal applies.
      syncDeal() {
        if (this.dealMin <= 1) return;
        const active = this.dealActive;
        this.classList.toggle('addons--locked', !active);
        if (!this.touched && this.dataset.preselect === 'true') {
          const first = this.querySelector('.addon__input:not(:disabled)');
          if (first) first.checked = active;
        }
      }

      get selected() {
        return [...this.querySelectorAll('.addon__input:checked')];
      }

      update() {
        const items = this.selected;
        if (!items.length) {
          this.summary.hidden = true;
          return;
        }
        const key = this.dealMin > 1 && !this.dealActive ? 'fullPrice' : 'price';
        const total = items.reduce((sum, input) => sum + Number(input.dataset[key]), 0) / 100;
        const t = this.dataset;
        const template = total === 0
          ? (items.length === 1 ? t.tFreeOne : t.tFreeOther)
          : (items.length === 1 ? t.tPaidOne : t.tPaidOther);
        this.summary.textContent = template
          .replace(/\{\{\s*count\s*\}\}/g, items.length)
          .replace(/\{\{\s*total\s*\}\}/g, this.money.format(total));
        this.summary.hidden = false;
      }

      async onSubmit(event) {
        const form = event.target;
        // getAttribute: the form has an input named "id", which shadows form.id
        if (!(form instanceof HTMLFormElement) || form.getAttribute('id') !== this.dataset.formId) return;
        if (form.dataset.addonsDone === 'true') {
          delete form.dataset.addonsDone;
          return;
        }
        const items = this.selected.map((input) => ({ id: Number(input.value), quantity: 1 }));
        if (!items.length) return;

        // Hold the theme's add-to-cart until the accessories are in the cart
        event.preventDefault();
        event.stopImmediatePropagation();
        this.error.hidden = true;
        this.classList.add('is-loading');
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!response.ok) {
            const data = await response.json().catch(() => ({}));
            throw new Error(data.description || this.dataset.tError);
          }
        } catch (error) {
          this.error.textContent = `${error.message} ${this.dataset.tErrorSuffix}`;
          this.error.hidden = false;
        } finally {
          this.classList.remove('is-loading');
          form.dataset.addonsDone = 'true';
          form.requestSubmit();
        }
      }
    }
    customElements.define('accessory-addons', AccessoryAddons);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["add-to-cart"] && !Shopify.designMode) return;
  try {
    // Keeps the small total on the add-to-cart button in step with the bundle picker
  // (radios named "quantity" carrying data-price / data-compare-price) and ticked accessory add-ons.
  (() => {
    const update = () => {
      document.querySelectorAll('.add-to-cart__total').forEach((total) => {
        const form = total.closest('form');
        const formId = form?.getAttribute('id');
        if (!formId) return;
        const bundle =
          document.querySelector(`input[name="quantity"][form="${formId}"]:checked[data-price]`) ||
          form.querySelector('input[name="quantity"]:checked[data-price]');
        if (!bundle) return;

        let price = Number(bundle.dataset.price);
        let compare = Number(bundle.dataset.comparePrice) || price;
        document.querySelectorAll(`accessory-addons[data-form-id="${formId}"]`).forEach((addons) => {
          const locked = addons.classList.contains('addons--locked');
          addons.querySelectorAll('.addon__input:checked').forEach((input) => {
            const full = Number(input.dataset.fullPrice);
            price += locked ? full : Number(input.dataset.price);
            compare += Math.max(Number(input.dataset.comparePrice) || full, full);
          });
        });

        const money = new Intl.NumberFormat(total.dataset.locale || undefined, {
          style: 'currency',
          currency: total.dataset.currency || 'USD',
          currencyDisplay: 'narrowSymbol',
        });
        total.querySelector('.add-to-cart__total-price').textContent = money.format(price / 100);
        const s = total.querySelector('.add-to-cart__total-compare');
        s.textContent = money.format(compare / 100);
        s.hidden = compare <= price;

        // Total saved (a bundle card's compare price already includes its free gifts)
        const saved = compare - price;
        const savedEl = total.querySelector('.add-to-cart__total-saved');
        if (savedEl) {
          savedEl.textContent = (total.dataset.tSave || '').replace(/\{\{\s*amount\s*\}\}/g, money.format(saved / 100));
          savedEl.hidden = saved <= 0;
        }
      });
    };
    // Run after the add-ons have re-synced their deal state for the same change
    document.addEventListener('change', () => setTimeout(update));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setTimeout(update));
    else setTimeout(update);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bundle-cards"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bundle-cards')) {
    class BundleCards extends HTMLElement {
      connectedCallback() {
        this.selectedLabel = this.querySelector('.bundle-cards__selected');
        this.error = this.querySelector('.bundle-cards__error');
        this.addEventListener('change', () => this.update());
        this.onSubmit = this.onSubmit.bind(this);
        window.addEventListener('submit', this.onSubmit, true);
        if (!this.selected) this.querySelector('.bundle-card__input')?.click();
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('submit', this.onSubmit, true);
      }

      get selected() {
        return this.querySelector('.bundle-card__input:checked');
      }

      update() {
        this.selectedLabel.textContent = this.selected?.dataset.title || '';
      }

      async onSubmit(event) {
        const form = event.target;
        // getAttribute: the form has an input named "id", which shadows form.id
        if (!(form instanceof HTMLFormElement) || form.getAttribute('id') !== this.dataset.formId) return;
        if (form.dataset.bundleCardsDone === 'true') {
          delete form.dataset.bundleCardsDone;
          return;
        }
        const addon = Number(this.selected?.dataset.addonId);
        if (!addon) return;

        // Hold the theme's add-to-cart until the add-on is in the cart
        event.preventDefault();
        event.stopImmediatePropagation();
        this.error.hidden = true;
        this.classList.add('is-loading');
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: addon, quantity: Number(this.selected.dataset.addonQuantity) || 1 }] }),
          });
          if (!response.ok) {
            const data = await response.json().catch(() => ({}));
            throw new Error(data.description || this.dataset.tError);
          }
        } catch (error) {
          this.error.textContent = `${error.message} ${this.dataset.tErrorSuffix}`;
          this.error.hidden = false;
        } finally {
          this.classList.remove('is-loading');
          form.dataset.bundleCardsDone = 'true';
          form.requestSubmit();
        }
      }
    }
    customElements.define('bundle-cards', BundleCards);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["photo-strip"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('photo-strip')) {
    class PhotoStrip extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.photo-strip__track');
        if (!this.track || !window.matchMedia('(pointer: fine)').matches) return;

        let startX = 0;
        let startScroll = 0;
        let moved = false;

        this.track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse') return;
          startX = event.clientX;
          startScroll = this.track.scrollLeft;
          moved = false;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(event.pointerId);
        });

        this.track.addEventListener('pointermove', (event) => {
          if (!this.track.classList.contains('is-dragging')) return;
          const delta = event.clientX - startX;
          if (Math.abs(delta) > 3) moved = true;
          this.track.scrollLeft = startScroll - delta;
        });

        const end = () => this.track.classList.remove('is-dragging');
        this.track.addEventListener('pointerup', end);
        this.track.addEventListener('pointercancel', end);

        this.track.addEventListener('click', (event) => {
          if (moved) event.preventDefault();
        }, true);
      }
    }
    customElements.define('photo-strip', PhotoStrip);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["review-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('review-slider')) {
    class ReviewSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = [...this.querySelectorAll('[data-review-slide]')];
        this.dots = this.querySelector('[data-dots]');
        if (!this.track || this.slides.length < 2) return;

        this.index = 0;
        this.dotButtons = this.slides.map((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'review-slider__dot';
          dot.setAttribute('aria-label', `Show review ${i + 1} of ${this.slides.length}`);
          dot.addEventListener('click', () => this.go(i, true));
          this.dots?.append(dot);
          return dot;
        });

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));

        this.track.addEventListener('scroll', () => {
          window.cancelAnimationFrame(this.frame);
          this.frame = window.requestAnimationFrame(() => {
            const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
            if (i !== this.index) this.setActive(i);
          });
        }, { passive: true });

        ['pointerenter', 'focusin', 'touchstart'].forEach((e) =>
          this.addEventListener(e, () => this.stop(), { passive: true })
        );
        ['pointerleave', 'focusout'].forEach((e) => this.addEventListener(e, () => this.start()));

        this.setActive(0);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      setActive(i) {
        this.index = i;
        this.dotButtons.forEach((dot, n) => dot.setAttribute('aria-current', n === i ? 'true' : 'false'));
      }

      go(i, userAction = false) {
        const count = this.slides.length;
        const next = (i + count) % count;
        this.track.scrollTo({ left: next * this.track.clientWidth, behavior: 'smooth' });
        this.setActive(next);
        if (userAction) this.stop();
      }

      start() {
        const seconds = Number(this.dataset.autoplay);
        if (!seconds || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.stop();
        this.timer = window.setInterval(() => this.go(this.index + 1), seconds * 1000);
      }

      stop() {
        window.clearInterval(this.timer);
      }
    }
    customElements.define('review-slider', ReviewSlider);
  }
  } catch(e) { console.error(e); }
})();

})();
